import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'

export interface Voivodeship {
  code: string
  labelPl: string
}

/** Read-only dictionary of 16 PL voivodeships. Stała - cache na zawsze. */
export function useVoivodeships() {
  return useQuery<Voivodeship[]>({
    queryKey: ['voivodeships'],
    queryFn: async () => (await api.get<Voivodeship[]>('/api/voivodeships')).data,
    staleTime: Infinity,
  })
}

/**
 * Mapuje kod województwa na polską nazwę. Zwraca surowy kod gdy spoza słownika
 * (np. stare dane prowizoryczne) lub gdy słownik jeszcze się ładuje.
 */
export function useVoivodeshipLabel(): (code: string | null | undefined) => string | null {
  const { data } = useVoivodeships()
  return (code) => {
    if (!code) return null
    return data?.find((v) => v.code === code)?.labelPl ?? code
  }
}
